module.exports = __webpack_public_path__ + "img/H5_02.f0c58bff.jpg";